import React from 'react'
import ColorPicker from '../colorpicker'
import {broadcast, listen, stop_listen, post_gql, text_layer, INIT_TEXT_SETTINGS} from '../../utils'
import './index.css'

class TextTool extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      mode: 'cursor',
      mouse_down_coords: false,
      container_mouse_coords: false,
      edit_layer_id: false,
      top: 10,
      left: 30,
      text_settings: INIT_TEXT_SETTINGS,
      user_id: false,
      hidden: false,
      common_hidden: false,
      layout_hidden: true,
      background_hidden: true,
      border_hidden: true,
      outline_hidden: true,
      listners: []
    }
  }

  componentDidMount(){
    const listners = [
      {type: "containter_onMouseMove", fnc: ({detail}) => {
        this.setState({container_mouse_coords: [detail.clientX, detail.clientY]})
        if (!!this.state.mouse_down_coords)
          this.setState({
            top: this.state.top + (detail.clientY - this.state.mouse_down_coords[1]),
            left: this.state.left + (detail.clientX - this.state.mouse_down_coords[0]),
            mouse_down_coords: [detail.clientX, detail.clientY]
          })
      }},
      {type: "toolbar_mode_change", fnc: ({detail}) => this.setState({mode: detail.mode, edit_layer_id: false})},
      {type: "set_text_settings", fnc: ({detail}) => this.setState({text_settings: detail})},
      {type: "toolbar_delete", fnc: ({detail}) => {
        if (this.state.edit_layer_id) {
          post_gql(
            `mutation {geomapLayerDelete(layer_id: ${this.state.edit_layer_id})}`,
            resp => {
              broadcast("remove_layer", this.state.edit_layer_id)
              broadcast("toolbar_mode_change", {mode: 'cursor'})
              broadcast("layer_edit", {id: false, type: "text"})
            }
          )
        }
      }},
      {type: "map_click", fnc: ({detail}) => {
        const obj = detail.event.object

        if (detail.mode === "cursor" && obj && !obj.bbox && !!obj.properties.text_settings) {
          this.setState({edit_layer_id: obj.properties.id, text_settings: obj.properties.text_settings})
          broadcast("layer_edit", {id: obj.properties.id, type: "text"})
          broadcast("text_settings", {user_id: this.props.user_id, text_settings: obj.properties.text_settings})
        } else {
          if (detail.mode === "text") {
            post_gql(
              `mutation { geomapLayerCreate(
                geomap_id: "${window.location.pathname.replace("/t/", "")}",
                user_id: "${this.props.user_id}",
                type: TEXT,
                point_coords: ${JSON.stringify(detail.event.coordinate)},
                text_settings: {
                  color: "${this.state.text_settings.color}",
                  opacity: ${this.state.text_settings.opacity},
                  text: ${JSON.stringify(this.state.text_settings.text)},
                  size: ${this.state.text_settings.size},
                  anchor: "${this.state.text_settings.anchor}",
                  alignment_baseline: "${this.state.text_settings.alignment_baseline}",
                  angle: ${this.state.text_settings.angle},
                  font_family: "${this.state.text_settings.font_family}",
                  font_weight: "${this.state.text_settings.font_weight}",
                  max_width: ${this.state.text_settings.max_width},
                  word_break: "${this.state.text_settings.word_break}",
                  background_padding_left: ${this.state.text_settings.background_padding_left},
                  background_padding_right: ${this.state.text_settings.background_padding_right},
                  background_padding_top: ${this.state.text_settings.background_padding_top},
                  background_padding_bottom: ${this.state.text_settings.background_padding_bottom},
                  background_color: "${this.state.text_settings.background_color}",
                  background_opacity: ${this.state.text_settings.background_opacity},
                  border_color: "${this.state.text_settings.border_color}",
                  border_opacity: ${this.state.text_settings.border_opacity},
                  border_width: ${this.state.text_settings.border_width},
                  outline_color: "${this.state.text_settings.outline_color}",
                  outline_opacity: ${this.state.text_settings.outline_opacity},
                  outline_width: ${this.state.text_settings.outline_width}
                }){id user_id point_coords type text_settings {
                      color opacity text size anchor alignment_baseline angle font_family font_weight max_width word_break
                      background_padding_left background_padding_right background_padding_top background_padding_bottom
                      background_color background_opacity border_color border_opacity border_width
                      outline_color outline_opacity outline_width
              }}}`,
              resp => {
                const props = resp.data.data.geomapLayerCreate
                broadcast("add_or_replace_layer", text_layer(props.point_coords, props))
              }
            )
          }
        }
      }},
      {type: "text_color", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, color: detail.value}})},
      {type: "text_opacity", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, opacity: detail.value}})},
      {type: "text_text", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, text: detail.value}})},
      {type: "text_size", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, size: detail.value}})},
      {type: "text_anchor", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, anchor: detail.value}})},
      {type: "text_alignment_baseline", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, alignment_baseline: detail.value}})},
      {type: "text_angle", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, angle: detail.value}})},
      {type: "text_font_family", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, font_family: detail.value}})},
      {type: "text_font_weight", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, font_weight: detail.value}})},
      {type: "text_max_width", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, max_width: detail.value}})},
      {type: "text_word_break", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, word_break: detail.value}})},
      {type: "text_background_padding_left", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, background_padding_left: detail.value}})},
      {type: "text_background_padding_right", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, background_padding_right: detail.value}})},
      {type: "text_background_padding_top", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, background_padding_top: detail.value}})},
      {type: "text_background_padding_bottom", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, background_padding_bottom: detail.value}})},
      {type: "text_background_color", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, background_color: detail.value}})},
      {type: "text_background_opacity", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, background_opacity: detail.value}})},
      {type: "text_border_color", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, border_color: detail.value}})},
      {type: "text_border_opacity", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, border_opacity: detail.value}})},
      {type: "text_border_width", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, border_width: detail.value}})},
      {type: "text_outline_color", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, outline_color: detail.value}})},
      {type: "text_outline_opacity", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, outline_opacity: detail.value}})},
      {type: "text_outline_width", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, outline_width: detail.value}})},

      {type: "update_text_color", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, color: detail.value}})},
      {type: "update_text_opacity", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, opacity: detail.value}})},
      {type: "update_text_text", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, text: detail.value}})},
      {type: "update_text_size", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, size: detail.value}})},
      {type: "update_text_anchor", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, anchor: detail.value}})},
      {type: "update_text_alignment_baseline", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, alignment_baseline: detail.value}})},
      {type: "update_text_angle", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, angle: detail.value}})},
      {type: "update_text_font_family", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, font_family: detail.value}})},
      {type: "update_text_font_weight", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, font_weight: detail.value}})},
      {type: "update_text_max_width", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, max_width: detail.value}})},
      {type: "update_text_word_break", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, word_break: detail.value}})},
      {type: "update_text_background_padding_left", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, background_padding_left: detail.value}})},
      {type: "update_text_background_padding_right", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, background_padding_right: detail.value}})},
      {type: "update_text_background_padding_top", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, background_padding_top: detail.value}})},
      {type: "update_text_background_padding_bottom", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, background_padding_bottom: detail.value}})},
      {type: "update_text_background_color", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, background_color: detail.value}})},
      {type: "update_text_background_opacity", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, background_opacity: detail.value}})},
      {type: "update_text_border_color", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, border_color: detail.value}})},
      {type: "update_text_border_opacity", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, border_opacity: detail.value}})},
      {type: "update_text_border_width", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, border_width: detail.value}})},
      {type: "update_text_outline_color", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, outline_color: detail.value}})},
      {type: "update_text_outline_opacity", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, outline_opacity: detail.value}})},
      {type: "update_text_outline_width", fnc: ({detail}) => this.setState({text_settings: {...this.state.text_settings, outline_width: detail.value}})},
    ]

    listners.forEach(l => listen(l.type, l.fnc))
    this.setState({listners})
  }

  componentWillUnmount(){this.state.listners.forEach(l => stop_listen(l.type, l.fnc))}

  render() {
    if (this.state.mode === 'text' || !!this.state.edit_layer_id){
      return(
        <div className="polygon-tool" style={{top: this.state.top, left: this.state.left}}>
          <div
            className="tool-header"
            onMouseDown={e => this.setState({mouse_down_coords: this.state.container_mouse_coords})}
            onMouseUp={e => this.setState({mouse_down_coords: false})}
          >
            <span className="tool-header-title">&nbsp;{this.state.edit_layer_id ? "редактирование" : "настройки"} текста</span>
            <div className="tool-header-btns">
              <span
                className="tool-header-btn"
                onClick={() => this.setState({hidden: !this.state.hidden})}
              >{this.state.hidden ? "▾" : "▸"}</span>
              <span
                className="tool-header-btn"
                style={{transform: `rotateZ(45deg)`}}
                onClick={() => {
                  broadcast("toolbar_mode_change", {mode: 'cursor'})
                  broadcast("layer_edit", {id: false, type: "text"})
                }}
              >+</span>
            </div>
          </div>
          {
            this.state.hidden ? null :
            <div className="tool-body">
              <div className="tool-input-cont">
                <textarea
                  className="tool-input-area"
                  value={this.state.text_settings.text}
                  onChange={e => broadcast(!!this.state.edit_layer_id ? "update_text_text" : "text_text", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: e.currentTarget.value})}
                />
              </div>

              <div className="tool-body-header" onClick={() => this.setState({common_hidden: !this.state.common_hidden})}>
                <span className="tool-header-title">&nbsp;&nbsp;основные</span>
                <span className="tool-header-btn">{this.state.common_hidden ? "▾" : "▸"}&nbsp;</span>
              </div> {
                this.state.common_hidden ? null :
                  <div>
                    <div className="tool-input-cont">
                      <ColorPicker user_id={this.props.user_id} object_id={this.state.edit_layer_id} broadcast_type={!!this.state.edit_layer_id ? "update_text_color" : "text_color"}/>
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">цвет</span>
                      <input
                        className="tool-input"
                        value={this.state.text_settings.color}
                        style={{backgroundColor: this.state.text_settings.color, color: 'white', textShadow: '0px 0px 4px black'}}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_text_color" : "text_color", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: e.currentTarget.value})}
                      />
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">прозрачность</span>
                      <input
                        className="tool-input"
                        value={this.state.text_settings.opacity}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_text_opacity" : "text_opacity", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: parseInt(e.currentTarget.value) || 0})}
                      />
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">размер</span>
                      <input
                        className="tool-input"
                        value={this.state.text_settings.size}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_text_size" : "text_size", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: parseInt(e.currentTarget.value) || 0})}
                      />
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">шрифт</span>
                      <select
                        value={this.state.text_settings.font_family}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_text_font_family" : "text_font_family", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: e.currentTarget.value})}
                      >
                        <option value="Monaco">Monaco</option>
                        <option value="Times New Roman">Times New Roman</option>
                        <option value="Georgia">Georgia</option>
                        <option value="Arial">Arial</option>
                        <option value="Arial Black">Arial Black</option>
                        <option value="Tahoma">Tahoma</option>
                        <option value="Verdana">Verdana</option>
                        <option value="Trebuchet MS">Trebuchet MS</option>
                        <option value="Lucida Sans Unicode">Lucida Sans Unicode</option>
                        <option value="Impact">Impact</option>
                        <option value="Comic Sans MS">Comic Sans MS</option>
                        <option value="Courier New">Courier New</option>
                        <option value="Lucida Console">Lucida Console</option>
                      </select>
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">жирность</span>
                      <select
                        value={this.state.text_settings.font_weight}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_text_font_weight" : "text_font_weight", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: e.currentTarget.value})}
                      >
                        <option value="100">100</option>
                        <option value="200">200</option>
                        <option value="300">300</option>
                        <option value="400">400</option>
                        <option value="500">500</option>
                        <option value="600">600</option>
                        <option value="700">700</option>
                        <option value="800">800</option>
                        <option value="900">900</option>
                      </select>
                    </div>
                  </div>
              }

              <div className="tool-body-header" onClick={() => this.setState({layout_hidden: !this.state.layout_hidden})}>
                <span className="tool-header-title">&nbsp;&nbsp;верстка</span>
                <span className="tool-header-btn">{this.state.layout_hidden ? "▾" : "▸"}&nbsp;</span>
              </div> {
                this.state.layout_hidden ? null :
                  <div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">гор. выравнивание</span>
                      <select
                        value={this.state.text_settings.anchor}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_text_anchor" : "text_anchor", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: e.currentTarget.value})}
                      >
                        <option value="start">право</option>
                        <option value="middle">центр</option>
                        <option value="end">лево</option>
                      </select>
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">верт. выравнивание</span>
                      <select
                        value={this.state.text_settings.alignment_baseline}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_text_alignment_baseline" : "text_alignment_baseline", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: e.currentTarget.value})}
                      >
                        <option value="top">верх</option>
                        <option value="center">центр</option>
                        <option value="bottom">низ</option>
                      </select>
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">угол</span>
                      <input
                        className="tool-input"
                        value={this.state.text_settings.angle}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_text_angle" : "text_angle", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: parseInt(e.currentTarget.value) || 0})}
                      />
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">макс. ширина</span>
                      <input
                        className="tool-input"
                        value={this.state.text_settings.max_width}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_text_max_width" : "text_max_width", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: parseInt(e.currentTarget.value) || 0})}
                      />
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">перенос строки</span>
                      <select
                        value={this.state.text_settings.word_break}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_text_word_break" : "text_word_break", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: e.currentTarget.value})}
                      >
                        <option value="break-word">слова</option>
                        <option value="break-all">буквы</option>
                      </select>
                    </div>

                    <div className="tool-input-cont">
                      <span className="tool-input-label">отступ слева</span>
                      <input
                        className="tool-input"
                        value={this.state.text_settings.background_padding_left}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_text_background_padding_left" : "text_background_padding_left", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: parseInt(e.currentTarget.value) || 0})}
                      />
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">отступ справа</span>
                      <input
                        className="tool-input"
                        value={this.state.text_settings.background_padding_right}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_text_background_padding_right" : "text_background_padding_right", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: parseInt(e.currentTarget.value) || 0})}
                      />
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">отступ сверху</span>
                      <input
                        className="tool-input"
                        value={this.state.text_settings.background_padding_top}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_text_background_padding_top" : "text_background_padding_top", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: parseInt(e.currentTarget.value) || 0})}
                      />
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">отступ снизу</span>
                      <input
                        className="tool-input"
                        value={this.state.text_settings.background_padding_bottom}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_text_background_padding_bottom" : "text_background_padding_bottom", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: parseInt(e.currentTarget.value) || 0})}
                      />
                    </div>
                  </div>
              }

              <div className="tool-body-header" onClick={() => this.setState({background_hidden: !this.state.background_hidden})}>
                <span className="tool-header-title">&nbsp;&nbsp;заливка</span>
                <span className="tool-header-btn">{this.state.background_hidden ? "▾" : "▸"}&nbsp;</span>
              </div> {
                this.state.background_hidden ? null :
                  <div>
                    <div className="tool-input-cont">
                      <ColorPicker user_id={this.props.user_id} object_id={this.state.edit_layer_id} broadcast_type={!!this.state.edit_layer_id ? "update_text_background_color" : "text_background_color"}/>
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">цвет</span>
                      <input
                        className="tool-input"
                        value={this.state.text_settings.background_color}
                        style={{backgroundColor: this.state.text_settings.background_color, color: 'white', textShadow: '0px 0px 4px black'}}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_text_background_color" : "text_background_color", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: e.currentTarget.value})}
                      />
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">прозрачность</span>
                      <input
                        className="tool-input"
                        value={this.state.text_settings.background_opacity}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_text_background_opacity" : "text_background_opacity", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: parseInt(e.currentTarget.value) || 0})}
                      />
                    </div>
                  </div>
              }

              <div className="tool-body-header" onClick={() => this.setState({border_hidden: !this.state.border_hidden})}>
                <span className="tool-header-title">&nbsp;&nbsp;граница</span>
                <span className="tool-header-btn">{this.state.border_hidden ? "▾" : "▸"}&nbsp;</span>
              </div>{
                this.state.border_hidden ? null :
                  <div>
                    <div className="tool-input-cont">
                      <ColorPicker user_id={this.props.user_id} object_id={this.state.edit_layer_id} broadcast_type={!!this.state.edit_layer_id ? "update_text_border_color" : "text_border_color"}/>
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">цвет</span>
                      <input
                        className="tool-input"
                        value={this.state.text_settings.border_color}
                        style={{backgroundColor: this.state.text_settings.border_color, color: 'white', textShadow: '0px 0px 4px black'}}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_text_border_color" : "text_border_color", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: e.currentTarget.value})}
                      />
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">прозрачность</span>
                      <input
                        className="tool-input"
                        value={this.state.text_settings.border_opacity}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_text_border_opacity" : "text_border_opacity", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: parseInt(e.currentTarget.value) || 0})}
                      />
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">толщина</span>
                      <input
                        className="tool-input"
                        value={this.state.text_settings.border_width}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_text_border_width" : "text_border_width", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: parseInt(e.currentTarget.value) || 0})}
                      />
                    </div>
                  </div>
              }

              <div className="tool-body-header" onClick={() => this.setState({outline_hidden: !this.state.outline_hidden})}>
                <span className="tool-header-title">&nbsp;&nbsp;обводка</span>
                <span className="tool-header-btn">{this.state.outline_hidden ? "▾" : "▸"}&nbsp;</span>
              </div> {
                this.state.outline_hidden ? null :
                  <div>
                    <div className="tool-input-cont">
                      <ColorPicker user_id={this.props.user_id} object_id={this.state.edit_layer_id} broadcast_type={!!this.state.edit_layer_id ? "update_text_outline_color" : "text_outline_color"}/>
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">цвет</span>
                      <input
                        className="tool-input"
                        value={this.state.text_settings.outline_color}
                        style={{backgroundColor: this.state.text_settings.outline_color, color: 'white', textShadow: '0px 0px 4px black'}}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_text_outline_color" : "text_outline_color", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: e.currentTarget.value})}
                      />
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">прозрачность</span>
                      <input
                        className="tool-input"
                        value={this.state.text_settings.outline_opacity}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_text_outline_opacity" : "text_outline_opacity", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: parseInt(e.currentTarget.value) || 0})}
                      />
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">толщина</span>
                      <input
                        className="tool-input"
                        value={this.state.text_settings.outline_width}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_text_outline_width" : "text_outline_width", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: parseInt(e.currentTarget.value) || 0})}
                      />
                    </div>
                  </div>
              }
            </div>
          }
        </div>
      )
    } else {
      return(null)
    }
  }
}

export default TextTool;
